import { Link } from "react-router-dom";
import Style from "../index.module.css";

const NotFound = () => {
  return (
    <div className={Style.container}>
      <h1 className={Style.title}>404</h1>
      <p className={Style.text}>A página que você procura não existe!</p>
      <Link to="/home" className={Style.button}>
        Voltar para Home
      </Link>
    </div>
  );
};

export default NotFound;
